// extracted by mini-css-extract-plugin
module.exports = {"details":"Details_details__1NNXe","location":"Details_location__3PLPn","row":"Details_row__2qwnq","col":"Details_col__x2bVI","price":"Details_price__enIuK"};